export const loadContainerParameters = 'loadContainerParameters';
export const loadContainerPriceMaps = 'loadContainerPriceMaps';
